import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styles from './UploadedImagePreview.scss';

class UploadedImagePreview extends Component {
  static propTypes = {
    fileDetails: ImmutablePropTypes.map,
    onRemove: PropTypes.func.isRequired,
  }

  onRemove = () => this.props.onRemove(this.props.fileDetails.get('id'));

  render() {
    const { fileDetails } = this.props;
    let shape = fileDetails.get('shape');
    const ratio = fileDetails.get('ratio');
    if (shape === 'square') {
      if (ratio != 1.0 && ratio > 0.9 && ratio < 1.1) {
        shape = 'square-ish';
      }
    }

    return (
      <div className={`${styles.imagePreview}`}>
        <div className="row align-items-center">
          <div className="col-4 col-lg-2">
            <img src={fileDetails.get('thumb_url')} className="img-fluid"/>
          </div>
          <div className="col-6 col-lg-8">
            <div className="row justify-content-start align-items-center">
              <div className="col-lg-6">
                <strong>File Name</strong>
                <br/>
                {fileDetails.get('filename')}
              </div>
              <div className="col-lg-2">
                <strong>Size</strong>
                <br/>
                {fileDetails.get('size_readable')}
              </div>
              <div className="col-lg-4">
                <strong>Dimensions</strong>
                <br/>
                {fileDetails.get('width')}x{fileDetails.get('height')} ({shape})
              </div>
            </div>
          </div>
          <div className="col text-right">
            <button onClick={this.onRemove} type="button" className="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadedImagePreview;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/UploadedImagePreview.jsx